module.exports = __webpack_public_path__ + "img/info_active.b140e8bf.svg";